import { render, staticRenderFns } from "./TheLoadScreen.vue?vue&type=template&id=58f6db4c&"
import script from "./TheLoadScreen.vue?vue&type=script&lang=js&"
export * from "./TheLoadScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports